/** SOC AI chat UI — welcome hub, suggestions, and thinking copy (production scenarios). */

export type WelcomeHubItem = {
  id: string;
  icon: string;
  label: string;
  message: string;
};

export const WELCOME_HUB_ITEMS: WelcomeHubItem[] = [
  { id: 'book', icon: 'book', label: 'Book Service', message: 'book a service' },
  { id: 'track', icon: 'track', label: 'Track Booking', message: 'track my orders' },
  { id: 'payment', icon: 'payment', label: 'Payment Help', message: 'payment help' },
  { id: 'support', icon: 'support', label: 'Support', message: 'talk to support' },
];

export const RECENT_SERVICE_CHIPS = ['AC Service', 'Plumbing', 'Kitchen Cleaning'] as const;

export const EXAMPLE_PROMPTS = [
  'My AC is leaking.',
  'Book plumber tomorrow.',
  'Track my booking.',
  'Download invoice.',
  'Need electrician.',
] as const;

export const THINKING_STEPS = [
  'Checking nearby technicians...',
  'Finding available slots...',
  'Calculating pricing...',
  'Preparing recommendation...',
] as const;

export const QUICK_SUGGESTION_CHIPS = ['Book Now', 'Track', 'Pricing', 'Support'] as const;

export const QUICK_SUGGESTION_LABELS: Record<(typeof QUICK_SUGGESTION_CHIPS)[number], string> = {
  'Book Now': 'Book Now',
  Track: 'Track',
  Pricing: 'Pricing',
  Support: 'Support',
};

export const DEFAULT_SUGGESTIONS = [
  'Book Now',
  'Track Booking',
  'Pricing',
  'Upload Image',
  'Speak',
  'Support',
  'Invoice',
  'Rate Service',
] as const;

export const SUGGESTION_MESSAGES: Record<string, string> = {
  'Book Now': 'book a service',
  '🏠 Book Now': 'book a service',
  'Track Booking': 'track my orders',
  '📍 Track Booking': 'track my orders',
  Track: 'track my orders',
  '📍 Track': 'track my orders',
  Pricing: 'cleaning price',
  '💰 Pricing': 'cleaning price',
  'Upload Image': 'diagnose with photo',
  '📷 Upload Image': 'diagnose with photo',
  Speak: 'book a service',
  '🎤 Speak': 'book a service',
  Support: 'talk to support',
  '📞 Support': 'talk to support',
  Invoice: 'download invoice',
  '🧾 Invoice': 'download invoice',
  'Rate Service': 'rate my last service',
  '⭐ Rate Service': 'rate my last service',
  '💳 Payment Help': 'payment help',
};

export const COMPLAINT_REASONS = [
  { label: 'Late Arrival', message: 'technician arrived late' },
  { label: 'No Show', message: 'technician did not arrive' },
  { label: 'Poor Behaviour', message: 'poor behaviour complaint' },
  { label: 'Wrong Service', message: 'wrong service complaint' },
  { label: 'Payment Issue', message: 'payment issue complaint' },
  { label: 'Other', message: 'other complaint' },
] as const;

export function timeOfDayGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 17) return 'Good Afternoon';
  return 'Good Evening';
}

export function suggestionsForFlow(flow: string): string[] {
  if (flow.startsWith('book_')) {
    return ['Payment Help', 'Track Booking', 'Book Now', 'Support'];
  }
  if (flow.startsWith('cancel_')) {
    return ['Support', 'Track Booking', 'Book Now'];
  }
  return ['Book Now', 'Track Booking', 'Pricing', 'Upload Image', 'Speak', 'Support', 'Invoice', 'Rate Service'];
}
